import { Component, OnInit, OnDestroy, EventEmitter, Input, Output, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import {SharedService} from '../../../shared.service';

/**
 * This displays the save and cancel buttons positioned to the right of wherever its placed.
 * Notably, it also displays the small sticky dialog above the footer for "Data saved successfully" or
 * "Data failed to save."
 * @Input() startOver: if it is true, it'll display a "Start Over" icon instead of the usual Cancel icon.
 *          All other functionality remains exactly identical.
 * @Input() saveEnabled: enables the save button. This is true by default.
 * @Input() cancelEnabled: enables the cancel button. This is true by default. Note, there is no image for disabled cancel right now.
 * @Input() saveServerEvent: An event emitter for booleans (if the server successfully or unsuccessfully saves)
 * @Ouput() saveButtonEvent: true if clicked on save, false if clicked on cancel
 */
@Component({
    selector: 'save-cancel-buttons',
    templateUrl: './save-cancel-buttons.component.html',
    styleUrls: ['./save-cancel-buttons.component.css']
})
export class SaveCancelButtonsComponent implements OnInit, OnDestroy {

    // Properties
    @Input() startOver = false;
    @Input() saveEnabled = true;
    @Input() cancelEnabled = true;
    @Input() saveServerEvent: EventEmitter<boolean>;  // True is success, false if failure
    @Output() saveButtonEvent: EventEmitter<boolean> = new EventEmitter<boolean> ();
    subscriptions: Subscription[] = [];

    // Class Functions
    constructor(
        private element: ElementRef,
        private sharedService: SharedService
    ) { }

    // Event Functions
    ngOnInit() {
        // POST: subscribes to the server save and produces the right messages
        if (this.saveServerEvent != null) {
            this.subscriptions.push(this.saveServerEvent.subscribe(save => {
                if (save) {
                    this.sharedService.showGoodSnackbar();
                } else {
                    this.sharedService.showBadSnackbar();
                }
            }));
        }
    }

    ngOnDestroy () {
        // POST: ends all subscriptions
        this.subscriptions.forEach (subscription => {
            subscription.unsubscribe ();
        });
    }
}
